import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Activity, Edit2, Filter, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Spinner, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {HiOutlineViewList} from "react-icons/hi";
import DeleteForecastContentResultModal from "./modals/DeleteForecastContentResultModal";
import AddForecastContentResultModal from "./modals/AddForecastContentResultModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Moment from "moment";

function getForecastContentResultsList() {

    return fetch('https://back-api.therunningcollective.fr/forecast-content-results', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getForecasts() {

    return fetch('https://back-api.therunningcollective.fr/forecasts', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getForecastContents() {

    return fetch('https://back-api.therunningcollective.fr/forecast-contents', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getForecastName(forecastID, forecasts){
    let output 
    forecasts.map(forecast => {
        if (forecast.id == forecastID){
            output = forecast.name
        }
    })
    //console.log(output)
    return output
}

function getForecastContentName(forecastID, forecasts){
    let output = forecastID
    forecasts.map(forecast => {
        if (forecast.id == forecastID){
            output = "("+(forecast.gender == "Hommes" ? "H" : forecast.gender == "Femmes" ? "F" : "Mixte")+") " + forecast.name + " - " + forecast.type
        }
    })
    //console.log(output)
    return output
}

function updateState(forecastContent, checked) {
    forecastContent.active = checked
    return fetch('https://back-api.therunningcollective.fr/forecast-content-result', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(forecastContent)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class ForecastContentResultsList extends Component {
    state = {
        errors: null,
        forecastContentResults: null,
        selectedForecastContent: {
            name: "",
            type: "",
            beginDate: "",
            forecastID: "",
            gender: "",
            athletes: [],
        },
    }

    async componentDidMount() {
        await getForecastContentResultsList().then(data => {
            if(data && !data.message){
                this.setState({forecastContentResults: data})
            }
        }).catch(err =>
            this.setState({errors: "error while getting forecastContentResults"})
        );
        await getForecasts().then(data => {
            this.setState({forecasts: data})
        }).catch(err =>
            this.setState({errors: "error while getting forecasts"})
        );
        await getForecastContents().then(data => {
            this.setState({forecastContents: data})
        }).catch(err =>
            this.setState({errors: "error while getting forecasts"})
        );
    };

    closeModal = () => this.setState({
        isOpen: false,
        isDelete: false,
        isDrawing: false,
        selectedForecast: {
            title: "",
            body: "",
        }
    });


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={11} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un résultat</Button>
                    </Col>
                    
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={11} className="products-buttons">
                        {(this.state.forecastContentResults && this.state.forecastContentResults.length > 0 && this.state.errors == null) ? <span>{this.state.forecastContentResults.length} résultat(s)</span> : null }
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des résultats, veuillez vous reconnecter"</p> : null}

                { (!this.state.forecastContentResults  && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Evenement</th>
                            <th>Épreuves</th>
                            <th>1ère place</th>
                            <th>2ème place</th>
                            <th>3ème place</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.forecastContentResults  && this.state.forecastContentResults.map(forecastContent => (
                            <tr>
                                <td>{this.state.forecasts && this.state.forecasts.length > 0 ? getForecastName(forecastContent.forecastID, this.state.forecasts) : null}</td>
                                <td>{this.state.forecastContents && this.state.forecastContents.length > 0 ? getForecastContentName(forecastContent.forecastContentID, this.state.forecastContents) : null}</td>
                                <td>{forecastContent.timeTable && forecastContent.timeTable.length > 0 ? forecastContent.timeTable.map(data => {
                                    return(
                                        <div>
                                            {data.name} - {data.firstPlaceAthlete.name}
                                        </div>
                                    )
                                }) : null}
                                </td>
                                <td>{forecastContent.timeTable && forecastContent.timeTable.length > 0 ? forecastContent.timeTable.map(data => {
                                    return(
                                        <div>
                                            {data.name} - {data.secondPlaceAthlete.name}
                                        </div>
                                    )
                                }) : null}
                                </td>
                                <td>{forecastContent.timeTable && forecastContent.timeTable.length > 0 ? forecastContent.timeTable.map(data => {
                                    return(
                                        <div>
                                            {data.name} - {data.thirdPlaceAthlete.name}
                                        </div>
                                    )
                                }) : null}
                                </td>
                                <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Modifier l'ajout du résultat</Tooltip>}
                                    >
                                        <td className="table-action" style={{cursor: "pointer"}}>
                                            <Edit2 className="align-middle mr-1" size={18}
                                                onClick={(e) => this.setState({isOpen: true, selectedForecastContent: forecastContent})}/>
                                        </td>
                                    </OverlayTrigger>
                                
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Supprimer l'ajout du résultat</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Trash className="align-middle" size={18}
                                               onClick={(e) => this.setState({isDelete: true, selectedForecastContent: forecastContent})}/>
                                    </td>
                                </OverlayTrigger>

                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddForecastContentResultModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedForecastContent={this.state.selectedForecastContent}
                        selectedForecast={this.state.selectedForecast}
                        availableUsers={this.state.availableUsers}
                        availableTypes={this.state.availableTypes}
                        forecasts={this.state.forecasts}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteForecastContentResultModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedForecastContent}
                        selectedCategory="forecastContent"
                    />
                    :
                    null
                }
            </div>
        );

    }
}